import React from "react";
import { Box, Grid, Rating, Stack } from "@mui/material";
import LandingHeader from "../../../layout/header";
import Footer from "../../../layout/footer";
import { BlueBox, BtnAccess, ReviewBox } from "../style";
import { RootStyle, Text, Title } from "../style";
import { AboutGrid, AboutText, AboutTitle } from "../style";
import AboutImg from "../../../images/landing/delivery module.png";
import Icon1 from "../../../images/landing/delivery icon 1.png";
import Icon2 from "../../../images/landing/delivery icon 2.png";
import Icon3 from "../../../images/landing/delivery icon 3.png";
import PartnerLogo from "../../../images/landing/sheikh.png";
import { Link } from "react-router-dom";
import AccessNow from "../AccessNow";
import { InnerBlueBox } from "../style";

function DeliveryModule() {
  return (
    <Box sx={{ background: "#fff" }}>
      <LandingHeader />
      <RootStyle sx={{ my: "40px" }}>
        <Stack spacing="64px">
          <BlueBox sx={{ minHeight: "163px" }}>
            <InnerBlueBox sx={{ p: "0 0 0 32px", maxHeight: "163px" }}>
              <Grid container>
                <AboutGrid item md={7} xs={12}>
                  <AboutTitle>Delivery Management System</AboutTitle>
                  <Link to="/inventory/login">
                    <BtnAccess>Access Now</BtnAccess>
                  </Link>
                </AboutGrid>
                <Grid item md={5} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
                  <Box>
                    <img
                      style={{ maxHeight: "163px" }}
                      width="100%"
                      src={AboutImg}
                      alt=""
                    />
                  </Box>
                </Grid>
              </Grid>
            </InnerBlueBox>
          </BlueBox>

          <Stack spacing="40px" alignItems="center">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Our cutting-edge system designed to revolutionize gatepass
              management and streamline your entire distribution process
            </AboutTitle>
            <img src={Icon1} alt="" />
          </Stack>

          <Box
            sx={{
              background: "#EFFFEC",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={8} xs={12} order={{ xs: 2, md: 1 }}>
                <AboutText>Key Features:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Order Placement:</b> Initiate the process by placing an
                      order in the system. The relevant details automatically
                      trigger the gatepass generation process.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Automated Gatepass Generation:</b> Say goodbye to
                      manual paperwork and tedious gatepass creation. Experience
                      the ease of automated gatepass generation, saving your
                      team valuable time and reducing errors.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Comprehensive Reporting:</b>Gain insights into your
                      distribution operations with detailed reports and
                      analytics. Identify trends, optimize routes, and make
                      informed decisions to enhance overall efficiency.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Security and Compliance:</b>Trust in a system that
                      prioritises the security of your data and compliance with
                      industry regulations. Managekaro ensures that your
                      gatepass information is secure and meets all necessary
                      standards.
                    </AboutText>
                  </li>
                </ul>
              </Grid>
              <Grid item md={4} xs={12} order={{ xs: 1, md: 2 }}>
                <img width="100%" src={Icon2} alt="" />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              background: "#EFFFEC",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={4} xs={12}>
                <img width="100%" src={Icon3} alt="" />
              </Grid>
              <Grid item md={8} xs={12}>
                <AboutText>Benefits:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Time Efficiency:</b>Automate the gatepass generation
                      process, eliminating the need for manual paperwork.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Reduced Errors:</b>Automation minimises the risk of
                      human errors in gatepass creation. Ensure accuracy in
                      documentation, leading to smoother operations.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Real-time Tracking and Visibility:</b> Keep track of
                      gatepasses and deliveries in real-time. Enhance visibility
                      into the status of each gatepass, allowing for better
                      coordination.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Comprehensive Reporting and Analytics:</b> Leverage
                      detailed reports and analytics to gain insights into
                      distribution patterns, delivery times, and resource
                      utilisation.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Audit Trail:</b> Keep a comprehensive audit trail of
                      all gatepass-related activities. Extract historical record
                      for compliance and reporting purposes.
                    </AboutText>
                  </li>
                </ul>
                <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                  The ManageKaro Gatepass feature offers a range of benefits
                  designed to enhance the efficiency, security, and overall
                  management of gatepasses in a distribution business.
                </AboutText>
              </Grid>
            </Grid>
          </Box>

          <ReviewBox>
            <Grid container spacing="16px">
              <Grid
                item
                md={6}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Stack>
                  <Text sx={{ color: "#fff" }}>
                    “The delivery management and gatepass features of ManageKaro
                    have transformed the way we handle our operations. One of
                    the standout benefits is the automated gatepass generation.
                    We've bid farewell to manual paperwork, reducing the chances
                    of errors and ensuring a seamless flow in our delivery
                    processes.Real-time tracking has become a game-changer for
                    us. With ManageKaro, we can monitor the status of every
                    gatepass and delivery in real-time. This level of visibility
                    enables us to proactively manage our deliveries, promptly
                    address any issues, and enhance overall efficiency.”
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <Rating name="simple-controlled" value={5} />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={PartnerLogo} alt="" />
                  <Box>
                    <Title sx={{ color: "#fff" }}>Sheikh Stationay</Title>
                    <Title sx={{ color: "#fff", fontSize: "24px" }}>
                      Mr Waleed
                    </Title>
                    <Text sx={{ color: "#fff", fontStyle: "italic" }}>
                      Mohan Pura, Near Afzal Food Point, Novelty Cinema,
                      Rawalpindi
                    </Text>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </ReviewBox>

          <AccessNow />
        </Stack>
      </RootStyle>
      <Footer />
    </Box>
  );
}

export default DeliveryModule;
